import { generateFooters } from '../../utils/react-utils';
import CommonFooter from '../common/Footer';
import { ProxyFooterProps } from '../common/ProxyFooter';
import ResetAccountLink from './ResetAccountLink';

export default function Footer({
  footerLinks,
  displayResetAccountLink,
  alwaysDisplayBackToSignIn,
  text,
  additionalOnClick,
}: ProxyFooterProps & { displayResetAccountLink?: boolean}) {
  let footers = generateFooters({
    footerLinks,
    alwaysDisplayBackToSignIn,
    additionalOnClick,
  });
  if (displayResetAccountLink) {
    const resetAccountFooter = <div key='reset-account-link'><ResetAccountLink /></div>;
    footers = ([ resetAccountFooter ] as React.ReactNode[]).concat(footers);
  }

  return <CommonFooter footerText={text} reactFooters={footers} />;
}
